import * as IconSelector from '../icons';

export const tipoHomologacion = [
    {
        value: 'Auxiliar',
        label: 'Auxiliar',
        description: 'Auxiliar',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Normalizado',
        label: 'Normalizado',
        description: 'Normalizado',
        icon: IconSelector.PointIcon,
        color: 'LightRed'
    }
];
